export const getQueryParameters = (): { [key: string]: string } => {
  const search = window.location.search.substr(1);
  const query = search.split('&');
  const params: { [key: string]: string } = {};
  query.forEach((part: string): void => {
    const item = part.split('=');
    params[item[0]] = decodeURIComponent(item[1]);
  });
  return params;
};
